import { render, staticRenderFns } from "./RecordslistItem.vue?vue&type=template&id=3853d81d"
import script from "./RecordslistItem.vue?vue&type=script&lang=js"
export * from "./RecordslistItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_84f1f4618b294cfa2aad13d74ae0562d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports